module.exports = __webpack_public_path__ + "20507c8d92ae23b4d9aaddcd156f3fc5.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/sounds/got-message.ogg
// module id = 1124
// module chunks = 0